import { firebaseApp } from "config/firebase/firebase";
import { getMessaging, getToken } from "firebase/messaging";
import { useEffect, useState } from "react";

const useFcmToken = () => {
  const [token, setToken] = useState("");
  const [permission, setPermission] = useState("");

  useEffect(() => {
    const retrieveToken = async () => {
      try {
        if (typeof window !== "undefined" && "serviceWorker" in navigator) {
          const messaging = getMessaging(firebaseApp);
          const permission = await Notification.requestPermission();
          setPermission(permission);

          if (permission === "granted") {
            const currentToken = await getToken(messaging, {
              vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            });

            if (currentToken) {
              setToken(currentToken);
            } else {
              console.log("no registration");
            }
          }
        }
      } catch (error) {
        console.log("error retrieve token", error);
      }
    };

    retrieveToken();
  }, []);

  return { token, permission };
};

export default useFcmToken;
